<template>
  <div class="chart-dialog">
    <el-dialog
      title="学生成绩对比图"
      :visible.sync="chartDialogShow"
      width="50%"
      :before-close="dialogClose"
    >
      <!-- 柱状图 -->
      <div
        id="myChart"
        ref="chart"
        style="height: 400px; width: 100%; margin: 0 auto"
      ></div>
    </el-dialog>
  </div>
</template>

<script>
import * as echarts from "echarts";
export default {
  props: ["chartDialogShow", "studentAvgScoreRankList", "courseFullList"],
  data() {
    return {
      myChart: null,
    };
  },
  watch: {
    chartDialogShow(newVal, oldVal) {
      if (newVal) {
        setTimeout(() => {
          // 初始化柱状图
          this.initChart();
        }, 200);
      }
    },
  },
  beforeDestroy() {
    this.clearChart();
  },
  methods: {
    // 销毁图例
    clearChart() {
      if (
        this.myChart != null &&
        this.myChart != undefined &&
        this.myChart != ""
      ) {
        this.myChart.dispose();
      }
    },
    // 关闭弹出窗口
    dialogClose() {
      this.$emit("update:chartDialogShow", false);
      this.clearChart();
    },
    initChart() {
      this.myChart = echarts.init(document.getElementById("myChart"));

      let o;
      let arr1 = [];
      let arr2 = [];
      let legendData = [];
      // console.log('111==>', this.studentAvgScoreRankList, this.courseFullList);

      // 将学生数据中的科目顺序按照分制的科目顺序重新排列
      var reorderedStudentData = this.studentAvgScoreRankList.map((student) => {
        var orderedSubjects = this.courseFullList.map((subjectName) => {
          var subject = student.courseInfoList.find(
            (s) => s.courseName === subjectName.courseName
          );
          if (!subject) return;
          // console.log('222==>', subject);
          return {
            courseName: subject.courseName,
            score: subject ? subject.score : null,
          };
        });

        return {
          studentName: student.studentName,
          avgScoreList: orderedSubjects,
        };
      });

      reorderedStudentData.forEach((v, i) => {
        legendData.push(v.studentName);
        arr2.push({ value: v.avgScoreList, name: v.studentName });
        this.courseFullList.forEach((cItem) => {
          v.avgScoreList.forEach((item, index) => {
            // console.log("333==>", cItem, item);
            if (!item || !cItem) return;
            if (cItem.courseName === item.courseName) {
              o = {
                text: cItem.courseName + cItem.fullScore,
                max: cItem.fullScore,
              };
              if (!arr1.find((aItem) => aItem.text === o.text)) {
                arr1.push(o);
              }
            }
          });
        });
      });

      arr2.forEach((item) => {
        item.value = item.value.map((vItem) => {
          if (!vItem) return;
          return vItem.score;
        });
      });
      // console.log(legendData, arr1, arr2);

      const option = {
        tooltip: {
          trigger: "item",
          axisPointer: {
            type: "shadow",
          },
          backgroundColor: "#fff", // 悬浮框背景色
          borderColor: "#000", // 悬浮框边框颜色
          borderWidth: 1, // 悬浮框边框宽度
          textStyle: {
            // 悬浮框文字样式
            color: "#000",
            fontSize: 12,
          },
        },
        legend: {
          data: legendData,
        },
        radar: {
          indicator: arr1,
        },
        series: [
          {
            name: "Budget vs spending",
            type: "radar",
            data: arr2,
          },
        ],
      };

      // 指定图表的配置项和数据
      this.myChart.setOption(option);
      //随着屏幕大小调节图表
      window.addEventListener("resize", () => {
        this.myChart.resize();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./barChartDialog.scss";
</style>